import { render } from "./boxDetailDecision.vue?vue&type=template&id=46bd06f9"
import script from "./boxDetailDecision.vue?vue&type=script&lang=js"
export * from "./boxDetailDecision.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__